import React, { useState, useEffect } from 'react';
import { FiArrowUp, FiArrowDown } from "react-icons/fi";
import Loader from "react-loader-spinner";
import { useTranslation } from "react-i18next";
import {toastMessage} from '../../utils/toast';
import { useSortableData } from '../../utils/sortableData';
import { clearSession } from '../../utils/initiate';
import Warning from '../Ui/400';
import ReactPaginate from 'react-paginate';
import '../../assets/table.css';
import DataCount from '../../utils/dataCount';
import AddModale from './addModale';
import * as additionalPaymentsActions from '../../Redux/Actions/additionalPayments';
import { useDispatch } from 'react-redux';
import { FiEdit2 } from 'react-icons/fi';
import { search } from '../../utils';

const AdditionalPayments = ({history}) => {

    let itemsPerPage = 10;
    const [permenentData, setPermenentData] = useState([]);
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [errStatus, setErrStatus] = useState(200);
    const [currentItems, setCurrentItems] = useState([]);
    const [pageCount, setPageCount] = useState(0);
    const [itemOffset, setItemOffset] = useState(0);
    const [addModale, setAddModale] = useState(false);
    const [updateId, setUpdateId] = useState('');
    const [filterName, setFilterName] = useState('');
    const [filterId, setFilterId] = useState('');
    const [clearFilterFlag, setClearFilterFlag] = useState(0);
    const { t } = useTranslation();
    const [buttonLoading, setButtonLoading] = useState(false);
    const dispatch = useDispatch();

    const {items, requestSort, sortConfig} = useSortableData(data);

    useEffect(() => {
        getAllAdditionalPayments();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        let temp = null;
        if(filterId && filterName) {
            const filtered = search({ filterSearch: filterId, items: permenentData, searchParams: ["id"] });
            temp = search({ filterSearch: filterName, items: filtered, searchParams: ["name"] });
        } else if (filterId) {
            temp = search({ filterSearch: filterId, items: permenentData, searchParams: ["id"] });
        } else if (filterName) {
            temp = search({ filterSearch: filterName, items: permenentData, searchParams: ["name"] });
        }
        temp && setData(temp);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [clearFilterFlag]);

    const getAllAdditionalPayments = () => {
        setLoading(true);
        additionalPaymentsActions.getAllAdditionalPayments().then((res) => {
            if(res?.data) {
                setPermenentData(res.data);
                setData(res.data);
            }
            setLoading(false);
        }).catch((err) => {
            setErrStatus(err.response.status);
            setLoading(false);
            (err.response.status === 401) && clearSession(dispatch, history);
        })
    }
    
    useEffect(() => {
        const endOffset = itemOffset + itemsPerPage;
        setCurrentItems(items.slice(itemOffset, endOffset));
        setPageCount(Math.ceil(items.length / itemsPerPage));
    }, [itemOffset, itemsPerPage, items]);


    const handlePageClick = (event) => {
        const newOffset = event.selected * itemsPerPage % data.length;
        setItemOffset(newOffset);
    };

    const addSubmitHandle = (payload) => {
        setButtonLoading(true);
        let action = updateId ? additionalPaymentsActions.updateAdditionalPayment(payload) : additionalPaymentsActions.createAdditionalPayments(payload);
        (action).then((res) => {
            if(res?.status === 200) {
                toastMessage('success', `Additional payment ${updateId ? 'updated' : 'created'} Successfully!`);
                window.location.reload();
            } else {
                toastMessage('error', `Unable to ${updateId ? 'update' : 'create'} additional payment!`);
            }
            setButtonLoading(false);
            setAddModale(false);
        }).catch((err) => {
            setButtonLoading(false);
            toastMessage('error', `Unable to ${updateId ? 'update' : 'create'} additional payment!`);
        });  
    }

    const substring = (str) => {
        return str.length <= 20 ? str : str.substring(0, 20) + '...';
    }

    const filterHandler = () => {
        if(filterId || filterName) {
            setClearFilterFlag((pre) => pre+1);
        }
    }

    const handleClearFilter = () => {
        setFilterId('');
        setFilterName('');
        setClearFilterFlag(0);
        setData(permenentData);
    }

    if(errStatus === 400){
        return <Warning history={history} />
    }
    
    return(
        <>
            <div className="container-fluid">
                <div className="page-title-box">
                    <h4 className="page-title my-2">{t("additionalPayments.title")}</h4>
                </div>
                <div className="row">
                    <div className="col-lg-12 col-xxl-12">
                        <div className="card card-custom card-stretch gutter-b">
                            <div className="card-body py-3">
                                <div className="tab-content">
                                    <div className="d-flex align-items-center mb-3">
                                        <div className="me-3" style={{ width: "20%" }}>
                                            <label className="mb-1 ms-1 me-3">
                                            {t("filter.id")}
                                            </label>
                                            <input
                                            placeholder={t("filter.idPlaceholder")}
                                            type="number"
                                            className="form-control me-3"
                                            name="Filter ID"
                                            value={filterId}
                                            onChange={(e) =>
                                                setFilterId(e.target.value)
                                            }
                                            />
                                        </div>
                                        <div className="me-3" style={{ width: "20%" }}>
                                            <label className="mb-1 ms-1 me-3">
                                            {t("filter.name")}
                                            </label>
                                            <input
                                            placeholder={t("filter.namePlaceholder")}
                                            type="text"
                                            className="form-control me-3"
                                            name="Filter ID"
                                            value={filterName}
                                            onChange={(e) =>
                                                setFilterName(e.target.value)
                                            }
                                            />
                                        </div>
                                    </div>
                                    <div className="d-flex align-items-center justify-content-between mb-3">
                                        <div className="d-flex" >
                                            <div className="d-flex align-items-end" style={{ width: '100%', whiteSpace: 'nowrap'}}>
                                                <button onClick={filterHandler} type="button" className="d-flex px-5 align-items-center btn btn-primary font-weight-bold" >{t("jobsManagement.filters.filter")}</button>
                                            </div>
                                            <div className="d-flex align-items-end" style={{ width: '100%', whiteSpace: 'nowrap', marginLeft: '15px' }}>
                                                <button onClick={handleClearFilter} type="button" className="px-5 d-flex align-items-center btn btn-primary font-weight-bold" >{t("jobsManagement.filters.clearFilters")}</button>
                                            </div>
                                        </div>
                                        <div className="d-flex justify-content-end mb-3">
                                            <div className="d-flex">
                                                <button type="button" onClick={() => setAddModale(true)} disabled={buttonLoading} className="d-flex align-items-center btn btn-primary font-weight-bold mt-3">
                                                    {t("additionalPayments.add")}
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                    {loading ? <Loader type="ThreeDots" color="#ad1a5f" height={40} width={40} style={{textAlign: 'center', marginBottom: '50px'}} />
                                        : <div className="table-responsive" style={{width: '100%', overflowX:'scroll'}}>
                                        <table className="table tableFreez table-head-custom table-vertical-center table-head-bg">
                                            <thead>
                                                <tr className="text-left" >
                                                    <th className="c-pointer" style={{textAlign: 'center'}} onClick={() => requestSort('id')}><span className={(sortConfig && (sortConfig.key === 'id')) ? "text-secondary" : "text-dark-75"}>{t("additionalPayments.id")} {(sortConfig && (sortConfig.key === 'id')) && ((sortConfig.direction === 'ascending') ? <FiArrowUp /> : <FiArrowDown />)}</span></th>
                                                    <th className="c-pointer" style={{textAlign: 'center'}} onClick={() => requestSort('name')}><span className={(sortConfig && (sortConfig.key === 'name')) ? "text-secondary" : "text-dark-75"}>{t("additionalPayments.name")} {(sortConfig && (sortConfig.key === 'name')) && ((sortConfig.direction === 'ascending') ? <FiArrowUp /> : <FiArrowDown />)}</span></th>
                                                    <th style={{textAlign: 'center'}}>{t("additionalPayments.electronicFee")}</th>
                                                    <th style={{textAlign: 'center'}}>{t("additionalPayments.vat")}</th>
                                                    <th style={{textAlign: 'center'}}>{t("additionalPayments.serviceFee")}</th>
                                                    <th style={{textAlign: 'center'}}>{t("additionalPayments.status")}</th>
                                                    <th style={{textAlign: 'center'}}>{t("additionalPayments.serviceFeeAvailable")}</th>
                                                    <th style={{textAlign: 'center'}}>{"Description"}</th>
                                                    <th style={{textAlign: 'center'}}>{t("jobsManagement.manageJobs.action")}</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {currentItems && currentItems.map(({ id, isServiceFee, name, serviceFee, status, vatAmountInPercentage, electronicFeeInPercentage, description },index) => {
                                                    return(
                                                        <tr key={index}>
                                                            <td className="pl-7">
                                                                <span className="text-dark-75 font-weight-bolder d-block font-size-lg" style={{textAlign: 'center'}}>{id}</span>
                                                            </td>
                                                            <td className="pl-7">
                                                                <span className="text-dark-75 font-weight-bolder d-block font-size-lg" style={{textAlign: 'center'}}>{name}</span>
                                                            </td>
                                                            <td className="pl-7">
                                                                <span className="text-dark-75 font-weight-bolder d-block font-size-lg" style={{textAlign: 'center'}}>{electronicFeeInPercentage}</span>
                                                            </td>
                                                            <td className="pl-7">
                                                                <span className="text-dark-75 font-weight-bolder d-block font-size-lg" style={{textAlign: 'center'}}>{vatAmountInPercentage}</span>
                                                            </td>
                                                            <td className="pl-7">
                                                                <span className="text-dark-75 font-weight-bolder d-block font-size-lg" style={{textAlign: 'center'}}>{serviceFee ? serviceFee : '-'}</span>
                                                            </td>
                                                            <td className="pl-7">
                                                                <span className="text-dark-75 font-weight-bolder d-block font-size-lg" style={{textAlign: 'center'}}>{status}</span>
                                                            </td>
                                                            <td className="pl-7">
                                                                <span className="text-dark-75 font-weight-bolder d-block font-size-lg" style={{textAlign: 'center'}}>{isServiceFee? 'Yes' : 'No'}</span>
                                                            </td>
                                                            <td className="pl-7">
                                                                <span className="text-dark-75 font-weight-bolder d-block font-size-lg" style={{textAlign: 'center'}}>{description ? substring(description) : '-'}</span>
                                                            </td>
                                                            <td className="pl-7" style={{textAlign: 'center'}}>
                                                                <FiEdit2 onClick={() => { setAddModale(true); setUpdateId(id)}}/>
                                                            </td>
                                                        </tr>
                                                    )})}
                                            </tbody>
                                        </table>
                                        {(pageCount > 1) && <ReactPaginate
                                                breakLabel="..."
                                                nextLabel=">"
                                                previousLabel="<"
                                                onPageChange={handlePageClick}
                                                pageRangeDisplayed={5}
                                                pageCount={pageCount}
                                                pageClassName="page-item"
                                                pageLinkClassName="page-link"
                                                previousClassName="page-item"
                                                previousLinkClassName="page-link"
                                                nextClassName="page-item"
                                                nextLinkClassName="page-link"
                                                breakClassName="page-item"
                                                breakLinkClassName="page-link"
                                                containerClassName="pagination"
                                                activeClassName="active"
                                                renderOnZeroPageCount={null}
                                            />}
                                             {(data.length === 0) && <p className="text-center mt-5 mb-5">{t("jobsManagement.noDataAvailable")}</p>}
                                    </div>}
                                    {data.length>0 && <DataCount itemOffset={itemOffset} items={items}/>}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {addModale && 
                    <AddModale 
                        t={t}
                        updateId={updateId}
                        showModale={addModale}
                        handleCancel={() => {setAddModale(false); setUpdateId('')}}
                        buttonLoading={buttonLoading}
                        handleOk={(payload) => {addSubmitHandle(payload)}}
                    />
                }
            </div>
        </>
    );
};

export default AdditionalPayments;